import { createAction } from '@reduxjs/toolkit';

export const eventWaitingToInplay = createAction('eventWaitingToInplay', ({ eventId }) => {

    return {
        payload: {
            eventId,
            changes: {
                tradable: false,
                active: false,
            },
        },
    };
});
